import { Box, Stack } from '@mui/material';

type Props = {
  children: React.ReactNode;
};

const LoadingSlide = ({ children }: Props) => (
  <Box
    sx={{
      position: 'relative',
      borderRadius: '8px',
      width: '100%',
      height: '100%',
    }}
  >
    <img
      src="https://static.treedis.com/assets/gallery-preview.webp"
      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      alt="gallery-preview"
    />
    <Stack
      spacing={1}
      sx={{
        position: 'absolute',
        zIndex: 2,
        width: '100%',
        bottom: 0,
        padding: 2,
        color: 'white',
      }}
    >
      {children}
    </Stack>
  </Box>
);

export default LoadingSlide;
